<div class="w-full mx-1 px-6 tab-frame">
    <div class="flex justify-between my-4">
        <div class="text-l" style="align-self: center;"> Equipment List </div>
    </div>

    <div class="overflow-x-auto mb-6">
        <table class="table table-zebra text-center">
            <thead class="header">
                <tr class="tableHeader-bg-color">
                    <td class="w-12"> No </td>
                    <td> Equipment Name </td>
                    <td> Equipment Brand / OEM </td>
                    <td> Installed Date </td>
                    <td class="w-16"> Action </td>
                </tr>
            </thead>
            <tbody>
                <ng-container *ngIf="(equipmentRegistration$ | async) as equipmentList; else noData">
                    <ng-container *ngIf="equipmentList.general.length > 0; else dataEmpty">
                        <tr *ngFor="let equipGeneralList of equipmentList.general; let i = index">
                            <td> {{ i + 1}}</td>
                            <td> {{ equipGeneralList.equipmentName == 'TR-SSSV' ? 'TRSCSSV' : equipGeneralList.equipmentName == 'WRSV' ? 'Retrievable Valve / Plug' : equipGeneralList.equipmentName }}</td>
                            <td> {{ equipGeneralList.equipmentBrand }}</td>
                            <td> {{ handleFormatDate(equipGeneralList.installedDate, false) }}</td>
                            <td class="flex">
                                <button class="btn btn-remove-bg">
                                    <mat-icon class="text-primary"  [svgIcon]="'heroicons_solid:eye'" matTooltip="View"
                                        (click)="viewEquipment(equipGeneralList)"></mat-icon>
                                </button>
                                <button class="btn btn-remove-bg">
                                    <mat-icon class="text-primary"  [svgIcon]="'heroicons_outline:document-chart-bar'" matTooltip="Equipment Registration History" (click)="viewEquipmentHistoricalData(equipGeneralList)"></mat-icon>
                                </button>
                            </td>
                        </tr>
                    </ng-container>
                </ng-container>
            </tbody>

            <ng-template #noData>
                <tr>
                    <td style="background-color: #f5f5f5;" colspan="10"> <b>No data available</b> <br> Please select
                        String to view </td>
                </tr>
            </ng-template>
            <ng-template #dataEmpty>
                <tr>
                    <td style="background-color: #f5f5f5;" colspan="10"> Well String are newly created, Please Insert Well Equipment Info
                </tr>
            </ng-template>
        </table>
    </div>
</div>